/* global rp$, document, window */
const get = require('lodash/get');
const paypalSmartButtons = require('../../../js/components/paypal-smart-buttons');

var THE_SCRIPT = function() {
	const $onReady = require("public/js/lib/on-ready");
	const { validatePostalCode } = require('public/js/lib/postal-code-helper');

	(function ProductInventoryMessagingModule() {
		function HandleInventoryMessageResponse({
			$inventoryMessageContentEle,
			$addToCartBtn,
			$inventoryWrap,
			$inventoryMessageIconWrap,
			$inventoryMessageSection
		}) {
			return function(evt, response) {
				$inventoryWrap.attr("hidden", true);
				$inventoryMessageSection.removeClass("product-in-stock-message");
				$inventoryMessageIconWrap.removeClass("hide");
				if (response.inventoryMessage) {
					if (response.inventoryMessageType === 'InStockMessagingOnly') {
						$inventoryMessageSection.addClass("product-in-stock-message");
						$inventoryMessageIconWrap.addClass("hide");
					}
					$inventoryMessageContentEle.text(response.inventoryMessage);
					$addToCartBtn.attr(
						"data-inventory-message",
						response.inventoryMessage
					);
					$inventoryWrap.attr("hidden", false);
				}

				// Update the tracking value to accurately depict what's on the page
				if (response.inventoryMessageType && window.tracking && (typeof window.tracking.dimensions === 'object')) {
					window.tracking.dimensions.stockLevelMessaging = response.inventoryMessageType;
				}
			};
		}

		function HandleZipCodeUpdate($postalCodeInput) {
			const postalCode = $postalCodeInput.val();
			const $messageDiv = rp$(".change-location-form .change-location-input-error");
			if (!validatePostalCode(postalCode)) {
				$messageDiv.show();
			} else {
				$messageDiv.hide();
				$ajax({
					dataType: "json",
					url: '/ajax/dealers',
					dataType: 'json',
					data: {
						postalCode,
					},
					success: (response, status /*, xhr*/) => {
						if (status === "success") {
							rp_app.location.reload();
						}
					}
				});
			}
		}

		function HandleDealerSelect(evt) {
			evt.preventDefault();
			const dealerHash = rp$(this).data("fulfillment-hash");
			if(!dealerHash ) {
				return;
			}

			$ajax({
				method: "POST",
				dataType: "json",
				url: "/ajax/dealers",
				data: {
					dealerHash
				},
				success: (response, status /*, xhr*/) => {
					if (status === "success") {
						rp_app.location.reload();
					}
				}
			});
		}

		function HandleViewMoreDealers(evt) {
			evt.preventDefault();

			window.rp_app.request({
				type: 'GET',
				url: '/ajax/cart',
				dataType: 'json',
				contentType: 'application/json',
				success: HandleViewMoreDealersRedirect,
			});
		}

		function HandleViewMoreDealersRedirect(cart) {
			const cartHasItems = !!get(cart, 'itemsCount');
			if (cartHasItems) {
				const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				if ($dealerSelectionWarningModal) {
					$dealerSelectionWarningModal.modal();
				}
			} else {
				ClearSelectedDealer();
			}
		}

		function ClearSelectedDealer() {
			$ajax({
				method: "GET",
				dataType: "json",
				url: "/ajax/dealers/clear",
				success: (response, status /*, xhr*/) => {
					if (status === "success") {
						rp_app.location.reload();
					}
				}
			});
		}

		$onReady({
			rp$,
			window,
			label: "product_purchase",
			fn: function() {
				const $inventoryMessageContentEle = rp$("#rp_inventory_message");
				const $addToCartBtn = rp$(".product-purchase button.add-to-cart");
				const $inventoryWrap = rp$("#inventory_wrap");
				const $inventoryMessageSection = rp$(".product-inventory-msg");
				const $inventoryMessageIconWrap = rp$(".inventory-icon-wrap");
				if ($inventoryMessageContentEle && $addToCartBtn) {
					const eventHandler = HandleInventoryMessageResponse({
						$inventoryMessageContentEle,
						$addToCartBtn,
						$inventoryWrap,
						$inventoryMessageIconWrap,
						$inventoryMessageSection
					});

					/* Handle inventory message Response
					.*-----------------------------------------*/
					// Due to plugin, all things that depend on document and window are up for causing bugs. Lets clean up before we start
					rp$(document).off(
						"productGetInventoryMessage:response",
						eventHandler
					);
					rp$(document).on("productGetInventoryMessage:response", eventHandler);
				}

				const $changeLocationSubmitBtn = rp$(".change-location-form button.change-location-submit");
				const $postalCodeInput = rp$(".change-location-form input.change-location-input");
				if ($changeLocationSubmitBtn && $postalCodeInput) {
					$changeLocationSubmitBtn.on("click", HandleZipCodeUpdate.bind(this, $postalCodeInput));
				}

				const $dealerSelect = rp$(".offer-dealer-list .dealer-select-button");
				if ($dealerSelect && $dealerSelect.length > 0) {
					$dealerSelect.each(function() {
						rp$(this).on("click", HandleDealerSelect);
					})
				}

				const $viewOffersLink = rp$(".purchase-box .view-offers-link");
				if ($viewOffersLink) {
					$viewOffersLink.on("click", HandleViewMoreDealers);
				}

				// viewOffersLink -> dealerSelectionWarningModal
				const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				const $warningModalContinueButton = rp$(".continue-button", $dealerSelectionWarningModal);
				$warningModalContinueButton.on("click", ClearSelectedDealer);

				// adding paypal payment message

				let sale_price = '';
				try {
					sale_price = rp$('.product-purchase-module').data('sale-price');
				} catch (e) {/* do nothing if sale price is empty or not having value */}

				const paymentsMessageContainerClass = '.pp-message';
				const paymentsMessageData = {
					elemOrSelector: paymentsMessageContainerClass,
					amount: sale_price,
					placement: 'product',
				}
				paypalSmartButtons.initPaypalMessage(paymentsMessageData);
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
